<div class="layout-footer">
    <img src="assets/layout/images/{{coreService.config.colorScheme === 'light' ? 'main-icon' : 'main-icon'}}.png" alt="Logo" height="20" class="mr-2"/>
    by
    <span class="font-medium ml-2">Video Download Admin</span>
</div>
